import { useState } from 'react'
import StackedSheet from './StackedSheet'

// AddPrayerSheet — "+ Add a prayer…" from PrayerListSheet, stacked over it
// (docs/FIX-PRAYER-LIST.md), same pattern as ReadingPlanDaySheet's Reflect
// answers sheet. A textarea + Just me / Share with [church] radio cards.

const GOLD = 'var(--gold)'
const SANS = "'Plus Jakarta Sans', system-ui, sans-serif"

export default function AddPrayerSheet({ open, onClose, churchName, onAdd }) {
  const [text, setText] = useState('')
  const [shareWithChurch, setShareWithChurch] = useState(false)
  const [saving, setSaving] = useState(false)

  async function save() {
    if (!text.trim() || saving) return
    setSaving(true)
    await onAdd(text.trim(), shareWithChurch)
    setSaving(false)
    setText('')
    setShareWithChurch(false)
    onClose?.()
  }

  return (
    <StackedSheet open={open} onClose={onClose} backLabel="Your prayer list" zIndex={450}>
      <div style={S.header}>
        <div style={{ flex: 1, fontSize: 16, fontWeight: 800, color: 'var(--ink)', textAlign: 'center' }}>Add a prayer</div>
        <button onClick={onClose} aria-label="Close" style={S.iconBtn}>✕</button>
      </div>
      <div style={S.scroll}>
        <textarea autoFocus value={text} onChange={e => setText(e.target.value)} placeholder="What's on your heart?"
          style={S.textarea}/>

        <div style={{ fontSize: 11, fontWeight: 800, letterSpacing: '0.06em', textTransform: 'uppercase', color: 'var(--stone)', margin: '18px 0 8px' }}>Who can see this</div>
        <button type="button" onClick={() => setShareWithChurch(false)} style={{ ...S.radioCard, ...(!shareWithChurch ? S.radioCardOn : {}) }}>
          <div style={S.radioDot}>{!shareWithChurch && <div style={S.radioDotFill}/>}</div>
          <div>
            <div style={S.radioTitle}>🔒 Just me</div>
            <div style={S.radioSub}>Only you can see this prayer.</div>
          </div>
        </button>
        <button type="button" onClick={() => setShareWithChurch(true)} style={{ ...S.radioCard, ...(shareWithChurch ? S.radioCardOn : {}) }}>
          <div style={S.radioDot}>{shareWithChurch && <div style={S.radioDotFill}/>}</div>
          <div>
            <div style={S.radioTitle}>👥 Share with {churchName || 'your church'}</div>
            <div style={S.radioSub}>Posted to the community prayer board too.</div>
          </div>
        </button>

        <button type="button" disabled={!text.trim() || saving} onClick={save} style={{ ...S.saveBtn, ...(!text.trim() ? S.saveBtnDis : {}) }}>
          {saving ? 'Saving…' : 'Add to your prayer list'}
        </button>
      </div>
    </StackedSheet>
  )
}

const S = {
  header: { flexShrink: 0, display: 'flex', alignItems: 'center', padding: '14px 16px', borderBottom: '1px solid var(--border)', minHeight: 54 },
  iconBtn: { background: 'rgba(31,27,22,0.06)', border: 'none', color: 'var(--stone)', width: 34, height: 34, borderRadius: 999, cursor: 'pointer', fontSize: 15, display: 'flex', alignItems: 'center', justifyContent: 'center' },
  scroll: { flex: 1, overflowY: 'auto', WebkitOverflowScrolling: 'touch', padding: '18px 16px calc(env(safe-area-inset-bottom) + 20px)', fontFamily: SANS },
  textarea: { width: '100%', minHeight: 110, resize: 'vertical', background: 'var(--white)', border: '1px solid var(--border-strong)', borderRadius: 14, padding: '12px 14px', color: 'var(--ink)', fontSize: 14.5, fontFamily: SANS, boxSizing: 'border-box', outline: 'none' },
  radioCard: { width: '100%', display: 'flex', gap: 12, alignItems: 'flex-start', background: 'var(--white)', border: '1.5px solid var(--border)', borderRadius: 16, padding: '12px 14px', marginBottom: 10, cursor: 'pointer', textAlign: 'left', fontFamily: SANS },
  radioCardOn: { border: `1.5px solid ${GOLD}`, background: 'var(--highlight)' },
  radioDot: { flexShrink: 0, width: 20, height: 20, borderRadius: 10, border: '1.5px solid var(--border-strong)', marginTop: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' },
  radioDotFill: { width: 10, height: 10, borderRadius: 5, background: 'var(--gold-ink)' },
  radioTitle: { fontSize: 14, fontWeight: 700, color: 'var(--ink)' },
  radioSub: { fontSize: 12, color: 'var(--stone)', marginTop: 2 },
  saveBtn: { width: '100%', marginTop: 10, background: GOLD, border: 'none', color: 'var(--ink)', borderRadius: 999, padding: '13px 10px', fontSize: 14, fontWeight: 800, cursor: 'pointer', fontFamily: SANS },
  saveBtnDis: { opacity: 0.5, cursor: 'default' },
}
